import { render } from "./vaftersaleflow.vue?vue&type=template&id=47d194b5&scoped=true"
import script from "./vaftersaleflow.vue?vue&type=script&lang=js"
export * from "./vaftersaleflow.vue?vue&type=script&lang=js"

import "./vaftersaleflow.vue?vue&type=style&index=0&id=47d194b5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d194b5"]])

export default __exports__